/**
 * Default confirm
 */
export default {
  methods: {
    async _confirm(message, shouldTranslate = true) {
      const msg = shouldTranslate ? this.$i18n.t(message) : message
      let confirmed = false
      confirmed = await this.$confirm(msg)
        .then(() => true)
        .catch(() => {
          confirmed = false
        })

      return !!confirmed
    },
  },
}
